var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityHamManu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6729 12.9143C10.6729 13.4983 10.9047 14.028 11.2817 14.4148C11.6565 14.7993 12.1798 15.0388 12.7594 15.0398C13.3389 15.0388 13.8611 14.7993 14.237 14.4148C14.6292 14.0107 14.8469 13.4733 14.8469 12.9143C14.8469 11.7422 13.9109 10.791 12.7583 10.791C11.6067 10.791 10.6729 11.7422 10.6729 12.9143Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7497 21.2097L16.8607 15.2373L15.1729 16.9457L21.064 22.9203L22.7497 21.2097Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 20.1793 5.7395 26 12.8212 26C12.8245 26 12.8267 26 12.8288 26C15.1179 26 17.2651 25.3901 19.0547 24.3566L16.1774 21.437L16.2348 21.4153C15.1862 21.8584 14.0324 22.1033 12.8223 22.1033H12.8212C7.86283 22.1033 3.84367 18.0083 3.84367 12.9599C3.84367 7.91158 7.86283 3.81658 12.8212 3.81658C14.0292 3.81767 15.1807 4.06142 16.1709 4.48067L18.9995 1.60983C17.1676 0.585 15.0616 0 12.8212 0C5.74058 0 0 5.82075 0 13Z",
    fill: "#8DC63F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1455 8.93444L16.8333 10.6429L22.7245 4.66935L21.0378 2.96094L15.1466 8.93444H15.1455Z",
    fill: "#8DC63F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityHamManu);
export default __webpack_public_path__ + "static/media/Activity_ham_manu.c62aff71e526d8167cb5a0c425351398.svg";
export { ForwardRef as ReactComponent };